const BASE_LEAVE_STATUS = {
  '00': '正常',
  '01': '年假(上午)',
  '02': '年假(下午)',
  '03': '休息',
  '04': '年假',
  '05': '事假(上午)',
  '06': '事假(下午)',
  '07': '事假',
  '08': '病假(上午)',
  '09': '病假(下午)',
  '10': '病假',
  '13': '替休',
  '14': '婚假',
  '15': '丧假',
  '16': '产假',
  '17': '出差',
  '18': '时替休',
  '19': '时年假',
  '20': '缺勤',
  '21': '迟到',
  '22': '早退',
  '23': '产检(时)',
  '25': '时事假',
  // '26': '时病假',
  '27': '哺乳假',
  '30': '加班',
  '40': '特批',
  '50': '小夜',
  '51': '大夜',
  '52': '正/小夜',
  '53': '大/小夜' }

const BASE_LEAVE_MENU = [
  {
    text: '年假',
    children: [
      { text: '年假', id: '04' },
      { text: '时年假', id: '19' },
      { text: '年假(上午)', id: '01' },
      { text: '年假(下午)', id: '02' }
    ]
  },
  {
    text: '替休',
    children: [
      { text: '替休', id: '13' },
      { text: '时替休', id: '18' }
    ]
  },
  {
    text: '事假',
    children: [
      { text: '事假', id: '07' },
      { text: '时事假', id: '25' },
      { text: '事假(上午)', id: '05' },
      { text: '事假(下午)', id: '06' }
    ]
  },
  {
    text: '病假',
    children: [
      { text: '病假', id: '10' },
      // { text: '时病假', id: '26' },
      { text: '病假(上午)', id: '08' },
      { text: '病假(下午)', id: '09' }
    ]
  },
  {
    text: '其他',
    children: [
      { text: '出差', id: '17' },
      { text: '丧假', id: '15' },
      { text: '产检(时)', id: '23' },
      { text: '哺乳假', id: '27' }
    ]
  }
]

const BASE_LEAVE_MENU_TENCENT = [
  {
    text: '年假',
    children: [
      { text: '年假', id: '04' },
      { text: '时年假', id: '19' },
      { text: '年假(上午)', id: '01' },
      { text: '年假(下午)', id: '02' }
    ]
  },
  {
    text: '事假',
    children: [
      { text: '事假', id: '07' },
      { text: '时事假', id: '25' },
      { text: '事假(上午)', id: '05' },
      { text: '事假(下午)', id: '06' }
    ]
  },
  {
    text: '病假',
    children: [
      { text: '病假', id: '10' },
      // { text: '时病假', id: '26' },
      { text: '病假(上午)', id: '08' },
      { text: '病假(下午)', id: '09' }
    ]
  },
  {
    text: '其他',
    children: [
      { text: '出差', id: '17' },
      { text: '丧假', id: '15' },
      { text: '产检(时)', id: '23' },
      { text: '哺乳假', id: '27' }
    ]
  }
]

const BASE_CREATE_NOTICEMSG = {
  '01': '实际工作满一年的正式员工每年可享受起始5天，逐年增长1天，最多10天的年假，不足一年按月份折算。最小请假单位为30分钟，不可一次休完，年末仍未休完不累计到下一年。',
  '02': '实际工作满一年的正式员工每年可享受起始5天，逐年增长1天，最多10天的年假，不足一年按月份折算。最小请假单位为30分钟，不可一次休完，年末仍未休完不累计到下一年。',
  '04': '实际工作满一年的正式员工每年可享受起始5天，逐年增长1天，最多10天的年假，不足一年按月份折算。最小请假单位为30分钟，不可一次休完，年末仍未休完不累计到下一年。',
  '19': '实际工作满一年的正式员工每年可享受起始5天，逐年增长1天，最多10天的年假，不足一年按月份折算。最小请假单位为30分钟，不可一次休完，年末仍未休完不累计到下一年。',
  '05': '员工申请事假不计发工资。不允许代为请假。最小请假单位为30分钟，每年不允许超过30日。',
  '06': '员工申请事假不计发工资。不允许代为请假。最小请假单位为30分钟，每年不允许超过30日。',
  '07': '员工申请事假不计发工资。不允许代为请假。最小请假单位为30分钟，每年不允许超过30日。',
  '25': '员工申请事假不计发工资。不允许代为请假。最小请假单位为30分钟，每年不允许超过30日。',
  '08': '员工申请病假需提交病例及相关说明材料。最小请假单位为半日。一年累计病假在12天（含）以内的，公司每天支付工资的50%。具体内容请到人事部了解。',
  '09': '员工申请病假需提交病例及相关说明材料。最小请假单位为半日。一年累计病假在12天（含）以内的，公司每天支付工资的50%。具体内容请到人事部了解。',
  '26': '员工申请病假需提交病例及相关说明材料。最小请假单位为半日。一年累计病假在12天（含）以内的，公司每天支付工资的50%。具体内容请到人事部了解。',
  '10': '员工申请病假需提交病例及相关说明材料。最小请假单位为半日。一年累计病假在12天（含）以内的，公司每天支付工资的50%。具体内容请到人事部了解。',
  '13': '员工实际时数超出应出勤时数，可享替休假。允许提前预支，预支额度不可超过年假剩余时数。超出前12个月的时数经抵扣后作废，最小请假单位为30分钟。',
  '18': '员工实际时数超出应出勤时数，可享替休假。允许提前预支，预支额度不可超过年假剩余时数。超出前12个月的时数经抵扣后作废，最小请假单位为30分钟。',
  '15': '员工因直系亲属（含祖父母、外祖父母）去世，经人事部确认后可申请3个自然日丧假（不可分期休假。丧假不含路程假，路程假具体内容请到人事部了解。',
  '17': ' ',
  '23': '女员工怀孕后，可享产前检查假。具体内容请到人事部了解。',
  '27': '女员工在婴儿满一周岁前可享哺乳假。每个工作日60分钟（多胞胎：每婴儿可增30分钟），最小单位为30分钟，可合并使用。具体内容请到人事部了解。' }

const BASE_LEAVE_HOUR = ['18', '19', '23', '25', '26', '27']
const BASE_LEAVE_DAYS = ['04', '07', '10', '13', '14', '15', '16', '17']
const BASE_LEAVE_HALF = ['01', '02', '05', '06', '08', '09']
const MEETING_TIME = ''

export default {
  BASE_LEAVE_STATUS,
  BASE_LEAVE_HOUR,
  BASE_LEAVE_HALF,
  BASE_LEAVE_DAYS,
  BASE_LEAVE_MENU,
  BASE_LEAVE_MENU_TENCENT,
  BASE_CREATE_NOTICEMSG,
  MEETING_TIME }
